import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

import type UploadFile from '../../interfaces/UploadFile';

interface Props {
  uploadFiles?: UploadFile[];
  onCancel?: () => void;
}

export const FilesUploadErrorForm = ({ uploadFiles, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="pt-6">
      <div className="mt-4 flex max-h-80 flex-col gap-2 divide-y divide-gray-medium overflow-auto border-y border-gray-medium">
        {uploadFiles?.map((uploadFile) => (
          <div key={uploadFile.id} className="flex flex-col gap-1 px-1 py-1.5">
            <span className="text-blue-dark">{uploadFile.fileName}</span>
            <span className="text-xs text-red-dark">{uploadFile.error}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-row items-center justify-end gap-2">
        <Button size="middle" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default FilesUploadErrorForm;
